export const CONSTS = {
    GOOGLE_MAPS_RGPD_URL: '/politique-de-confidentialite',
    REFRESH_BLOCK_ATTRIBUTES_API_REQUEST_TIMEOUT_IN_MS: 5000,
    MONCLUB_BASE_URL: 'https://monclub.ffhandball.fr/',
    COMPETITION_CFK_ATTRIBUTES_NAME: 'data-cfk',
    UPDATE_PAGE_HEADER_EVENT_NAME: 'page-header-update',
    STRUCTURE_FALLBACK_LOGO_PATH: '/app/themes/ffhandball/img/logo_generic_club.png',
    FLAGS_FOLDER: '/app/themes/ffhandball/img/flags',
    GOOGLE_MAPS_CONSENT_DURATION_IN_MONTHS: 1,
}

export const isDev = process.env.NODE_ENV === 'development'
export const isProd = process.env.NODE_ENV === 'production' // It can't be !isDev because we can be in staging mode
